export default function urlHelper(url) {
  if (!url) return null
  const BASE_URL = '/rootstech/rtc2021/'
  const urlParts = url?.split(BASE_URL) // TO DO: Ask for relative url from brightspot
  const relativePart = urlParts?.[1] ? `/${urlParts?.[1]}` : null
  return relativePart ?? url
}
export const getSessionTypeFromURL = (routeUrl) => {
  let sessionType
  if (routeUrl?.includes('/registered-session/')) {
    sessionType = 'LiveSession'
  } else if (routeUrl?.includes('/live-session/')) {
    sessionType = 'LiveSession'
  } else if (routeUrl?.includes('/session/')) {
    sessionType = 'ClassSessionPage'
  } else if (routeUrl?.includes('/tips/')) {
    sessionType = 'TipsAndTricksPage'
  } else if (routeUrl?.includes('/genealogyreveal/')) {
    sessionType = 'GenealogyRevealPage'
  } else if (routeUrl?.includes('/traditions/')) {
    sessionType = 'TraditionsAndHolidaysPage'
  } else if (routeUrl?.includes('/languagevideo/')) {
    sessionType = 'LanguageVideoPage'
  } else if (routeUrl?.includes('/virtualtour/')) {
    sessionType = 'VirtualTourPage'
  } else if (routeUrl?.includes('/yourhometown/')) {
    sessionType = 'YourHometownPage'
  } else if (routeUrl?.includes('/recipe/')) {
    sessionType = 'RecipePage'
  } else if (routeUrl?.includes('/fashionshow/')) {
    sessionType = 'FashionShowPage'
  } else if (routeUrl?.includes('/howtodance/')) {
    sessionType = 'HowToDancePage'
  }
  return sessionType
}

export const getComeUntoChristUrl = (locale) => {
  const urlMap = {
    /* Main 10 */
    en: 'https://www.comeuntochrist.org/' /* English */,
    de: 'https://www.comeuntochrist.org/deu?lang=deu' /* German | Deutsch (not dutch!) */,
    es: 'https://www.veniracristo.org/?lang=spa' /* Spanish | Espanol */,
    fr: 'https://www.venezauchrist.org/?lang=fra' /* French | Francais */,
    it: 'https://www.comeuntochrist.org/ita?lang=ita' /* Italian | italiano */,
    pt: 'https://www.vindeacristo.org/?lang=por' /* Portuguese | Português */,
    ru: 'https://www.comeuntochrist.org/rus?lang=rus' /* Russian | Русский */,
    ko: 'https://www.comeuntochrist.org/kor?locale=kor' /* Korean |  한국말 */,
    ja: 'https://www.comeuntochrist.org/jpn?lang=jpn' /* Japanese | 日本語 */,
    zh: 'https://www.comeuntochrist.org/zho?lang=zho' /* Chinese | 中文 */,
    /* Other Languages */
    da: 'https://www.comeuntochrist.org/dan?lang=dan' /* Danish | Dansk */,
    el: 'https://www.comeuntochrist.org/ell?lang=ell' /* Greek | Ελληνικά */,
    fi: 'https://www.comeuntochrist.org/fin?lang=fin' /* Finnish | Suomi */,
    hr: 'https://www.comeuntochrist.org/hrv?lang=hrv' /* Croatian | Hrvatski jezik */,
    hu: 'https://www.comeuntochrist.org/hun?lang=hun' /* Hungarian | Magyar */,
    cs: 'https://www.comeuntochrist.org/ces?lang=ces' /* Czech | Česky */,
    hy: 'https://www.comeuntochrist.org/hye?lang=hye' /* Armenian | հայերեն */,
    id: 'https://www.comeuntochrist.org/ind?lang=ind' /* Indonesian | Indonesia */,
    lv: 'https://www.comeuntochrist.org/lav?lang=lav' /* Latvian | Latvijas */,
    nl: 'https://www.comeuntochrist.org/nld?lang=nld' /* Dutch | Nederlands */,
    no: 'https://www.comeuntochrist.org/nor?lang=nor' /* Norwegian | Norsk */,
    pl: 'https://www.comeuntochrist.org/pol?lang=pol' /* Polish | Polski */,
    ro: 'https://www.comeuntochrist.org/ron?lang=ron' /* Romanian | Română */,
    sq: 'https://www.comeuntochrist.org/alb?lang=alb' /* Albanian | Shqip */,
    sv: 'https://www.comeuntochrist.org/swe?lang=swe' /* Swedish | Svenska */,
    th: 'https://www.comeuntochrist.org/tha?lang=tha' /* Thai | ไทย */,
    uk: 'https://www.comeuntochrist.org/ukr?lang=ukr' /* Ukrainian | українська */,
  }
  return urlMap[locale]
}
